
import axios from 'axios';
import { useQuery } from 'react-query';
import { PostTagDto } from '../model/types'

const POST = `/api/admin/tags`;

export const useGetPostTags = () => {
  return useQuery<PostTagDto[]>(
    ['post-tags'],
    async () => {
      const { data } = await axios.get(`${POST}/`);
      return data;
    },
    {
      refetchOnWindowFocus: false,
    },
  );
};
